import React from 'react';
import '../Media.css';

function Videos() {
  const videos = [
    {
      title: "HCHS Living History Series Interview with Barbara Lee Brown Teas",
      producer: "Amy Ahlbrand Robinson, M.Ed.",
      description: "Barbara Lee Brown Teas is a third generation Houstonian who remembers growing up in the 1930s and '40s Houston Heights, attending Eugene Field Elementary, the fear of the Houston polio epidemic, fun times at Lamar High School and swimming as a “Corkette” at The Shamrock.  Barbara Lee owned a very successful travel agency, Globe-Trotters, Inc., and has volunteered for many years at Richmond State School. Her memories also include her family of jewelers, dining at The Shamrock, riding the Houston trolley downtown, and dining at Felix Restaurant. She has a wonderful family and now there are now six generations of Brown/Teas from Houston.",
      youtubeId: "8VKHpjnkAZU",
      date: "2025"
    },
    {
      title: "HCHS Living History Series Interview with Ed McMahon",
      producer: "Amy Ahlbrand Robinson, M.Ed.",
      description: "Native Houstonian Ed McMahon joined the Harris County Historical Society Board and the Bryan Museum Board of Directors in 2019. He also serves on the Executive Committee of the Houston Livestock Show and Rodeo, is a Director of the Western Art Museum in Kerrville, TX, and is a Citizens for Animal Protection member. A founding member of “Men of Distinction” supporting Texas Children’s Hospital and co-founder of “Women of Distinction,” McMahon is also associated with the National Cowboy & Western Heritage Museum and Baylor College of Medicine. With over 50 years of philanthropic service in Houston, McMahon has been a dedicated volunteer for the Houston Livestock Show and Rodeo, where he has held leadership roles, including Executive Director, for many years.",
      youtubeId: "JGDpkinpVbE",
      date: "2024"
    },
    {
      title: "The 1910 Harris County Courthouse",
      producer: "Texas Foundation for the Arts",
      description: " ",
      youtubeId: "yBbHiU-eYpY",
      date: "2019"
    },
    {
      title: "Houston Ship Channel: Deep Water Centennial",
      producer: "Texas Foundation for the Arts",
      description: "The Houston Ship Channel is celebrating its centennial as a deep water port in 2014, and a new documentary explores the rich history, as well as present-day operations of the Houston Ship Channel and the Port of Houston, one of the busiest ports in the United States.",
      youtubeId: "6UR_aj5DsM8",
      date: "2014"
    },
    {
      title: "Post Oak Boulevard: A Texas Legacy",
      producer: "Texas Foundation for the Arts",
      description: "Uptown Houston is often called Houston’s ‘second downtown’. But not too long ago this stylish neighborhood was home to dusty farms and vegetable stands. From the early settlers to shopping mecca and urban oasis... 'Post Oak Boulevard: A Texas Legacy' examines the transformation of Houston’s most glamorous address. This program was produced by Texas Foundation for the Arts.",
      youtubeId: "cfwuFWEMDE4",
      date: "2016"
    },
    {
      title: "Galveston, Hurricanes and \"The Wizard of Oz\" by Amy Ahlbrand Robinson",
      producer: "Amy Ahlbrand Robinson, M.Ed.",
      description: "A digital storytelling research project for a University of Houston art education graduate class uncovers an interesting connection between the devastating Hurricane of 1900, Galveston's Vidor family, and the movie, \"The Wizard of Oz.\" The story also documents Hurricane Ike's effects on Galveston and its ancient oak trees.",
      youtubeId: "DWrDuMe7wfc",
      date: "2015"
    }
  ];

  return (
    <div className="media">
      <section className="page-hero">
        <h1>Video Gallery</h1>
        <p>Watch our collection of historical documentaries and presentations</p>
      </section>

      <div className="page-container">
        <div className="videos-grid">
          {videos.map((video, index) => (
            <div key={video.youtubeId} className="card video-card">
              <h3>{video.title}</h3>
              <p className="producer">{video.producer} • {video.date}</p>
              <div className="video-embed">
                <iframe
                  src={`https://www.youtube.com/embed/${video.youtubeId}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <p className="description">{video.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Videos; 